import {Injectable, inject} from "@angular/core";
import {Observable} from "rxjs";
import {
    ForecastImportApiService,
    ForecastImportVerifyResult,
    ForecastImportCommitResult,
    ForecastImportSummary,
    ForecastImportDetail,
    ForecastMergeRequest,
    ForecastMergeStarted,
    ForecastMergeJobStatus
} from "../generated-sources/api/forecast-import";

@Injectable({providedIn: "root"})
export class ForecastImportService {
    private readonly forecastImportApiService = inject(ForecastImportApiService);

    /** Location of the committed blank template served as a static asset. */
    readonly templateUrl = "assets/Template_import.xlsx";

    verify(file: File): Observable<ForecastImportVerifyResult> {
        return this.forecastImportApiService.verifyForecastImport(file);
    }

    commit(file: File): Observable<ForecastImportCommitResult> {
        return this.forecastImportApiService.commitForecastImport(file);
    }

    listImports(): Observable<ForecastImportSummary[]> {
        return this.forecastImportApiService.listForecastImports();
    }

    getImport(importId: number): Observable<ForecastImportDetail> {
        return this.forecastImportApiService.getForecastImport(importId);
    }

    /** Starts the async merge; resolves to the background job's taskInfoId (poll getMergeJobStatus). */
    merge(importId: number, request?: ForecastMergeRequest): Observable<ForecastMergeStarted> {
        return this.forecastImportApiService.mergeForecastImport(importId, request);
    }

    getMergeJobStatus(taskInfoId: number): Observable<ForecastMergeJobStatus> {
        return this.forecastImportApiService.getForecastMergeJobStatus(taskInfoId);
    }
}
